import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';

import { i18n } from '@/utils/i18n';

//Locales
const error_name = i18n.t('settings.edit_name.name_required');
const error_lastName = i18n.t('settings.edit_name.lastname_required');

//Schema
const editNameSchema = Yup.object().shape({
  name: Yup.string().required(error_name),
  lastname: Yup.string().required(error_lastName)
});

//Data
export type EditNameData = Yup.InferType<typeof editNameSchema>;

//Resolver
export const editNameResolver = yupResolver(editNameSchema);
